export enum Key {
    Backspace = "Backspace",
    Enter = "Enter",
    Escape = "Escape",
    Space = " ",
}
